import { IMAGES } from "../../lib/images";

export default function BrandStory() {
  return (
    <section
      id="legacy"
      data-testid="brand-story-section"
      className="relative bg-ivory py-24 md:py-40"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-5 md:col-start-1 reveal">
            <p className="text-overline text-gold mb-6">Forty Years of Devotion</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.08] text-maroon tracking-tight">
              A brushstroke that
              <br />
              started at <span className="italic">40 years ago.</span>
            </h2>
            <div className="mt-10 space-y-6 text-[15px] md:text-base text-maroon/80 leading-[1.85] max-w-xl">
              <p>
                She began painting at just seventeen. Today, at sixty,
                her hands still move with the same patience, the same attention,
                the same love for her craft.
              </p>
              <p>
                For four decades her art lived quietly — mostly within the
                four walls of our home. Not because she wasn't exceptional,
                but because she never got the stage she truly deserved.
              </p>
              <p className="font-display italic text-maroon text-lg md:text-xl">
                ARVI is the stage. A tribute. A son's promise fulfilled.
              </p>
            </div>

            <div className="mt-12 flex items-center gap-10">
              <div>
                <p className="font-display text-5xl text-maroon">40+</p>
                <p className="text-overline text-maroon/60 mt-2">Years of Practice</p>
              </div>
              <div className="h-14 w-px bg-[hsl(var(--gold)/0.5)]" />
              <div>
                <p className="font-display text-5xl text-maroon">100%</p>
                <p className="text-overline text-maroon/60 mt-2">Hand-Painted</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-7 reveal">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-full h-full border border-[hsl(var(--gold)/0.55)]" aria-hidden="true" />
              <img
                src={IMAGES.story}
                alt="Hands painting delicate floral motifs — forty years of practice"
                className="relative w-full h-[480px] md:h-[620px] object-cover"
                loading="lazy"
              />
              <p className="mt-5 text-overline text-maroon/60">
                Plate 01 — Studio, hand at work
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
